import { motion } from "framer-motion";

export const EASE = [0.2, 0.8, 0.2, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", as = "div", ...rest }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </M>
  );
};

const lineV = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 1, ease: EASE, delay: i } }),
};

// Masked line-by-line headline reveal. Observer lives on the unclipped wrapper.
export const MaskLines = ({ lines, as = "h2", className = "", delay = 0, stagger = 0.12, onMount = false, testId }) => {
  const M = motion[as];
  const trigger = onMount ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.1 } };
  return (
    <M className={className} initial="hidden" {...trigger} data-testid={testId}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.06em] -mb-[0.06em]">
          <motion.span className="block" variants={lineV} custom={delay + i * stagger}>
            {line}
          </motion.span>
        </span>
      ))}
    </M>
  );
};
